import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgTicket = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.2 12c0-.963.81-1.75 1.8-1.75v-3.5C21 5.787 20.19 5 19.2 5H4.8c-.99 0-1.791.787-1.791 1.75v3.5c.99 0 1.791.787 1.791 1.75s-.801 1.75-1.8 1.75v3.5c0 .962.81 1.75 1.8 1.75h14.4c.99 0 1.8-.788 1.8-1.75v-3.5c-.99 0-1.8-.787-1.8-1.75z",
			fillRule: "nonzero"
		})
	})
});
export default SvgTicket;
